import React from 'react';
import '../../styles/App.css';
import '../../styles/Table.css'


/**
 * Calibration Table Class for NAOVins, renders calibration data associated with NAV Vehicles
 *
 * @author Ethan Jones
 */
class CalibrationTable extends React.Component{

    /**
     * Constructor for CalibrationTable class, instantiates the chain of parts to be displayed
     * @param props
     */
    constructor(props) {
        super(props);
        if(this.props.hardwareId === -1){
            this.state.chainOfParts = this.props.chainOfParts
        }
        else{
            if(this.props.progSeqData.isNaoCalDataPartDecision !== undefined){
                if(this.props.progSeqData.partDecisionExists[this.props.moduleId]){
                    this.state.chainOfParts = this.props.progSeqData.partDecisionCopMap[this.props.moduleId][this.props.hardwareId]
                }else{
                    this.state.chainOfParts = this.props.chainOfParts
                }
            }else {
                if (this.props.progSeqData.dependencyDataExists[this.props.moduleId]) {
                    this.state.chainOfParts = this.props.progSeqData.dependencyDataCopMap[
                        this.props.moduleId][this.props.hardwareId]
                } else {
                    this.state.chainOfParts = this.props.chainOfParts
                }
            }
        }
    }

    state = {
        chainOfParts: null
    }


    /**
     * Renders calibration data for NAOVehicles when they have hardware dependencies
     * @returns {*}
     */
    renderCalTableFromHWD(){
        return(
            <table>
                <tr>
                    <th>Part Number</th>
                    <th>CVN</th>
                    <th>Description</th>
                </tr>
                <React.Fragment>
                    {this.props.chainOfParts.map((data, index) => (
                        <tr>
                            <td>{data.partNumber}</td>
                            <td>{this.props.cvnMap[data.partNumber]}</td>
                            <td>{data.displayName.controllerLabel}</td>
                        </tr>
                    ))}
                </React.Fragment>
            </table>
        )
    }

    /**
     * Renders the Calibration Data for NAOVehicles
     * @returns {*}
     */
    renderCalTable(){
        return(
            <div>
                <label className={"CalTableLabel"}>
                    {this.props.moduleName}
                </label>
                <table className={"CalibrationTable"}>
                    <tr>
                        <th>Part Number</th>
                        <th>CVN</th>
                        <th>Description</th>
                    </tr>
                    {this.state.chainOfParts && this.state.chainOfParts.map((data,index)=>(
                        <tr>
                            <td>{data[0]}</td>
                            <td>{this.props.progSeqData.cvnMap[data[0]]}</td>
                            <td>{data[2]}</td>
                        </tr>
                    ))}
                </table>
            </div>
        )
    }

    /**
     * Main render method for Calibration Table
     * @returns {*}
     */
    render(){
        return(
            <React.Fragment>
                {this.renderCalTable()}
            </React.Fragment>
        )
    }

}

export default CalibrationTable;